import axios from '../plugins/axios';

const API_URL = '/admin/course-schedules';

export default {
  async getSchedules(filters = {}) {
    let url = API_URL;
    
    if (filters.course) {
      url += `?_filters_[]=course__contains&course__contains=${encodeURIComponent(filters.course)}`;
    }
    
    console.log('API Request URL:', url);
    
    try {
      const response = await axios.get(url);
      console.log('API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async addSchedule(scheduleData) {
    const response = await axios.post(API_URL, scheduleData);
    return response.data;
  },

  async updateSchedule(scheduleId, scheduleData) {
    const response = await axios.put(`${API_URL}/${scheduleId}`, scheduleData);
    return response.data;
  },

  async deleteSchedule(scheduleId) {
    const response = await axios.delete(`${API_URL}/${scheduleId}`);
    return response.data;
  }
}; 